import type { OpportunityListType } from "app/pages/sales-intelligence/sub-modules/opportunities/types";

import { BASE_OPPORTUNITY_LIST_URL } from "./const";

export const createStaticListUrl = (listId: OpportunityListType["opportunityListId"], path?: string): string =>
    `${BASE_OPPORTUNITY_LIST_URL}/${listId}${path ?? ""}`;
